import logo2 from "../images/logo2.png"
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
function Rodape() {

    const date = new Date();

    return (
        <footer id="contem-rodape-info">
            <div id="form" className="row rodape-info" style={
                    { 
                        textAlign: "center",
                        width: "90%", 
                        margin: "auto", 
                        padding: "20px 0px", 
                        display: "flex", 
                        justifyContent:"space-between", 
                    }
                }>
                <div id="rodape-info-left" className="col-12 col-sm-6"  style={{ textAlign: "left" }}>
                    <p>
                        <img id="logo-rodape" src={logo2} alt="Logo 2" /><br/>
                        Venha conhecer esta empresa que não
                        para de crescer e descobrir porque que a
                        CODEF é considerada uma referência
                        nacional em vendas de ferramentas,
                        máquinas, equipamentos e EPI´s.
                    </p>

                </div>
                <div id="rodape-info-right" className="col-12 col-sm-6" style={{ textAlign: "left", paddingTop: "10px", maxWidth: "320px" }}>
                    <p className="rodape-endereco" style={{ marginBottom: "20px" }}>
                        CNPJ: 13.454.806/0001-00<br/>
                        RAZÃO SOCIAL: CODEF COMERCIAL DE FERRAMENTAS LTDA.<br/>
                        ENDEREÇO: Rua Barão de Cotegipe,<br/>
                        Mares, 191, CEP 40.445.001, Salvador-BA
                    </p>
                    <p className="rodape-tels">
                        <FaPhone /> (71) 3310-2222<br/>
                    </p>
                </div>
            </div>
            <div className="cp">
                Todos os direitos reservados © {date.getFullYear()} CODEF
            </div>
        </footer>
    );
}   

export default Rodape;